import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';

import rootSaga from '@/store/sagas';
import rootReducer from '@/store/root.reducer';

const sagaMiddleware = createSagaMiddleware();
const middleware: any[] = [sagaMiddleware];

// Add redux-logger middleware only in development mode
if (import.meta.env.MODE === 'development') {
  const loggerMiddleware = createLogger();
  middleware.push(loggerMiddleware);
}

const store = configureStore({
  reducer: rootReducer,
  middleware: [...middleware],
});
/**
 * @constructor calling root saga
 * */
sagaMiddleware.run(rootSaga);
export default store;
